import { gql } from '@apollo/client/core';
import { useCallback } from 'react';

import { useTrackAmplitudeEvent } from 'support/amplitude/amplitudeEvent';
import { useUpdateTrackReviewMutation } from 'types/graphql';

import { TrackReviewFeedbackForm } from '../track-review-feedback-form/TrackReviewFeedbackForm';

export interface TrackReviewFeedbackProps {
  toThankYouPage: () => void;
  reviewID: string;
}

gql`
  mutation UpdateTrackReview($id: String!, $content: String!) {
    updateTrackReview(id: $id, content: $content) {
      id
    }
  }
`;

export const TrackReviewFeedback = ({ toThankYouPage, reviewID }: TrackReviewFeedbackProps) => {
  const [updateReview, { loading, error }] = useUpdateTrackReviewMutation();
  const trackAmplitudeEvent = useTrackAmplitudeEvent();

  const onUpdateReview = useCallback(
    async (content: string) => {
      await updateReview({
        variables: {
          id: reviewID,
          content,
        },
      });
      trackAmplitudeEvent({ name: 'Lab - Feedback - Sent' });
      toThankYouPage();
    },
    [reviewID, toThankYouPage, updateReview, trackAmplitudeEvent],
  );

  return <TrackReviewFeedbackForm error={error} loading={loading} onUpdateReview={onUpdateReview} />;
};
